import './collapse.less';
import './faq.less';
import './static_page.less';
import classNames from 'classnames';

import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
const Collapse = require('rc-collapse');
const Panel = Collapse.Panel;
import $ from 'jquery';
import {Link} from 'react-router';
import Header from '../header/header';
import Footer from '../footer/footer';

import DashBoardHeader from '../header_dashboard/dashboard_header';
import cookies from '../util/cookie';
import authActions from '../auth/auth_actions';

class Faq extends React.Component {
  constructor(props) {
    super(props);
      this.logout = this.logout.bind(this);
  }

  logout() {
    this.props.authActions.logout().always(() => {
        cookies.delete('_sd');
        document.location.href = '/';
    });
  }

  render() {

    const {state, props} = this;
    let user = {
      name: '',
      imageUrl: '',
      isVerified: ''
    };
    let isSessionValid = false;

    if('userData' in props.authState){
      isSessionValid  = props.authState.userData.sessionValid
    }

    if(isSessionValid && props.authState){
        user.name = props.authState.userData.name;
        user.imageUrl = props.authState.userData.profileImageUrl;
        user.isVerified = props.authState.userData.isVerified;
    }

    return (
      <div className="static-page faq-page">
        {!isSessionValid && <Header isFixedHeader={true} /> }
        {isSessionValid &&  <DashBoardHeader user = {user} logout={this.logout} /> }
        <div className = {classNames('static-header-wrap', {'no-margin-top' : isSessionValid})}>
          <h1 className = "static-header">FAQ</h1>
        </div>
        <div className = "static-page-wrapper">
          <Collapse accordion={true}>
            <Panel header="How do I find a carrier?">Carriers find you! When you use the app to make a request, it posts immediately and travelers heading to your destination will see it and respond.</Panel>
            <Panel header="How much does it cost?">The standard fee is 10% of the value of the item. For items under $200, the minimum $20 fee applies. Feel free to sweeten the deal by offering more. That will improve your chances of finding a carrier and help convince someone to take a heavy or bulky item. </Panel>
            <Panel header="How do I find shippers??">After you register, simply click on “browse packages to carry” and you will see all the requests from your area. You can sort them by destination, package size, and value. When you find an assignment that fits your travel plans, respond. </Panel>
            <Panel header="How much does the carrier get?">Carriers receive 80% of the shipping fee and AirWayBill gets 20%. AWB takes care of all the transactions.</Panel>
            <Panel header="Can I cancel an order?">If you change your mind after a carrier has accepted your offer but before the item has been picked up you can cancel and pay a 5% fee. If you cancel after the pickup, you will be charged the full fee.</Panel>
            <Panel header="How do I know my package will be safe?">The carrier has every reason to take good care of your item, because its full value will be deducted from the carrier’s credit card if the delivery is not made, and value of the item will be refunded.</Panel>
            <Panel header="How do I know the right person is getting the delivery?">We use a double-check security system to make sure items reach the right person. The carrier checks the ID of the person who is there to receive the item and sends it to the shipper. The receiver must also show a six-digit code from the shipper that the carrier confirms. </Panel>
            <Panel header="What if my item is seized at customs?">Before accepting an item, shippers and carriers should make sure it is legal to bring it into the destination country. If an illegal item is seized, the carrier is responsible for the cost of the item. If a legal item is seized improperly, AirWayBill will help recover it.</Panel>
            <Panel header="What if the carrier is asked to pay duty on the item?">Carriers have to first understand if the item requires custom clearance and how much the duty is. If the shipper agrees to pay the custom, carrier can declare and pay on shipper’s behalf. AirWayBill will reimburse the carrier and charge the shipper.</Panel>
            <Panel header="How does a shipper pay?">Enter your credit card number and wait for verification. It will be automatically charged when the transaction is completed. </Panel>
            <Panel header="How does a carrier paid?">Payments are made through PayPal. Register you PayPal account and you will automatically receive your payment when the transaction is completed. </Panel>
            <Panel header="Can a carrier transport more than one item?">You can carry as many items as your luggage space (and your credit card limit) allows! Make the most out of your trip by carrying more than one item. </Panel>
            <Panel header="Can shippers and carriers talk to each other?">Once there is an accepted offer, the shipper or the carrier can tab on the “call” button, which will call the other party’s phone number. Shipper and receiver can also message each other on AirWayBill application. </Panel>
            <Panel header="What if the price of a requested shopping item changes?">Carriers have to make sure that the buyer approves of the new price before making the purchase. If you are already in touch with the other party, feel free to cancel your original request and post another with the updated price. If the carrier accepts the new offer you’re done—no fees are charged for the update. </Panel>
         </Collapse>
       </div>
       <Footer />
      </div>
    );
  }
}


//connect Login modal and signup modal with actions and state
const mapStateToProps = (state) => {
  return {
    authState : state.app.auth || {}
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      authActions : bindActionCreators(authActions, dispatch)
  }
}

Faq = connect(
  mapStateToProps,
  mapDispatchToProps
)(Faq)


export default Faq;



// WEBPACK FOOTER //
// app/static_pages/faq.jsx